'use client';

import type { FC } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import {
  useCarousel,
  useSelectedSnap,
} from '@wwe-portal/ui/components/carousel';

import { NextArrowIcon } from '../../component/next-arrow-icon';

export const FlagshipPagination: FC<{ duplication: number }> = ({
  duplication,
}) => {
  const { scrollNext, scrollPrev } = useCarousel();
  const { api } = useCarousel();
  const nodes = api?.slideNodes();
  const currentIndex = useSelectedSnap();

  const totalNodes = nodes?.length;

  if (!totalNodes || totalNodes < 2) {
    return null;
  }

  const actualTotal = Math.floor(totalNodes / duplication);

  return (
    <div className="flex h-[46px] justify-center">
      <ClickableDiv
        className="cursor-pointer self-center p-3"
        onClick={scrollPrev}
      >
        <NextArrowIcon className="rotate-180" />
      </ClickableDiv>
      <div className="text-text300 border-back200 bg-back600 flex items-center gap-[6px] rounded-[8px] border-[2px] border-solid px-6 text-sm">
        <span className="font-semibold">
          {(currentIndex % actualTotal) + 1}
        </span>
        <span>/</span>
        <span>{actualTotal}</span>
      </div>
      <ClickableDiv
        className="cursor-pointer self-center p-3"
        onClick={scrollNext}
      >
        <NextArrowIcon />
      </ClickableDiv>
    </div>
  );
};
